import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/language/LanguageContext';
import { pidakatBaseData } from '../../utils/pidakatBaseData';
import './PidakatBase.css';

const PidakatBase = () => {
    const { language } = useLanguage();
    const data = pidakatBaseData[language];

    return (
        <div className="pidakat-base-page">
            <div className="education-hero">
                <div className="education-hero-content">
                    <h1>{data.title}</h1>
                    <p className="hero-subtitle-edu">{data.subtitle}</p>
                </div>
                <div className="education-pattern"></div>
            </div>

            <div className="education-container">
                <div className="grades-grid">
                    {data.grades.map((grade, index) => (
                        <Link to={grade.path} key={index} className="grade-card">
                            <div className="grade-number">{(index + 1).toString().padStart(2, '0')}</div>
                            <h3>{grade.name}</h3>
                            <div className="grade-actions">
                                <span className="see-more-text">{language === 'my' ? 'အသေးစိတ်ကြည့်ရန် ' : 'See More '}</span>
                                &nbsp;
                                <i className="fas fa-arrow-right"></i>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="exam-schedule-card">
                    <h3>{data.examSchedule.title}</h3>
                    <div className="schedule-content">
                        <div className="schedule-periods">
                            {data.examSchedule.periods.map((period, index) => (
                                <div key={index} className="period-item">
                                    <div className="period-icon">
                                        <i className="fas fa-calendar-alt"></i>
                                    </div>
                                    <p>{period}</p>
                                </div>
                            ))}
                        </div>
                        <div className="schedule-frequency">
                            <i className="fas fa-sync-alt"></i>
                            <p>{data.examSchedule.frequency}</p>
                        </div>
                    </div>
                </div>

                <div className="note-card">
                    <div className="note-icon">
                        <i className="fas fa-info-circle"></i>
                    </div>
                    <p>{data.examSchedule.note}</p>
                </div>

                <div className="summary-section">
                    <h2>{data.summary.title}</h2>
                    <div className="books-grid">
                        {data.summary.books.map((book, index) => (
                            <div key={index} className="book-item">
                                <span className="book-number">{(index + 1).toString().padStart(2, '0')}</span>
                                <span className="book-title">{book}</span>
                            </div>
                        ))}
                    </div>
                    <p className="summary-note">{data.summary.note}</p>
                </div>

            </div>
        </div>
    );
};

export default PidakatBase;